import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Jane D.",
  quote: "The Story Haven has been a sanctuary for my child to express and heal.",
  position: "Parent",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_mother_safe_space.png",
  initials: "JD"
}, {
  author: "Dr. Smith",
  quote: "A vital resource for clinicians integrating storytelling into therapy.",
  position: "Child Psychologist",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_male_clinician.png",
  initials: "DS"
}, {
  author: "Carlos R.",
  quote: "My son found hope and courage through their storytelling programs.",
  position: "Parent",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_hispanic_father_hopeful.png",
  initials: "CR"
}, {
  author: "Emily Johnson",
  quote: "Seeing the transformation in these children is the most rewarding part of my career.",
  position: "Program Director",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_diverse_woman_leadership.png",
  initials: "EJ"
}, {
  author: "Michael Lee",
  quote: "Art and movement unlock stories that words sometimes cannot reach.",
  position: "Creative Arts Coordinator",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/avatar_asian_creative_arts_lead.png",
  initials: "ML"
}];
export default function VoicesOfHope() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="voices-of-hope" className="relative overflow-hidden bg-background py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex justify-center overflow-hidden">
        <div className="bg-secondary/30 absolute -top-[20%] left-1/2 h-[600px] w-[600px] -translate-x-1/2 rounded-full blur-3xl" />
        <div className="bg-accent/20 absolute top-[40%] right-0 h-[400px] w-[400px] translate-x-1/3 rounded-full blur-3xl" />
      </div>

      <div className="container relative mx-auto px-6">
        <div ref={ref} className={`mb-16 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="text-primary font-serif text-4xl font-medium tracking-tight sm:text-5xl">
            Voices of Hope
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            Hear from the families, clinicians, and team members who make The
            Story Haven a place of healing and connection.
          </p>
        </div>

        <div className={`transition-all duration-1000 delay-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="mx-auto w-full max-w-6xl">
            <CarouselContent className="-ml-4 pb-4">
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full p-1">
                    <Card className="bg-secondary border-white/60 shadow-sm hover:shadow-md transition-shadow duration-300 h-full rounded-3xl">
                      <CardContent className="flex flex-col justify-between h-full p-8">
                        <div>
                          <Quote className="text-ring/40 mb-6 size-8 fill-current" />
                          <blockquote className="font-serif text-primary text-xl leading-relaxed">
                            &ldquo;{item.quote}&rdquo;
                          </blockquote>
                        </div>

                        <div className="mt-8 flex items-center gap-4">
                          <SafeHydrate><Avatar className="size-12 border-2 border-white shadow-sm">
                            <AvatarImage src={item.avatar} alt={item.author} className="object-cover" />
                            <AvatarFallback className="bg-white text-primary font-medium">
                              {item.initials}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          <div>
                            <div className="text-primary font-semibold">
                              {item.author}
                            </div>
                            <div className="text-muted-foreground text-sm">
                              {item.position}
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="mt-12 flex justify-center gap-4 md:absolute md:top-1/2 md:-left-12 md:-right-12 md:mt-0 md:justify-between md:pointer-events-none">
              <CarouselPrevious className="border-ring text-ring hover:bg-ring hover:text-white pointer-events-auto static size-12 rounded-full border bg-transparent transition-colors md:absolute md:left-0 md:-translate-y-1/2" />
              <CarouselNext className="border-ring text-ring hover:bg-ring hover:text-white pointer-events-auto static size-12 rounded-full border bg-transparent transition-colors md:absolute md:right-0 md:-translate-y-1/2" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}